const ContactType = {
  EMAIL: 'email',
  WEBSITE: 'website',
  MOBILE: 'mobile',
  LINKED_IN: 'linked_in',
  GITHUB: 'github',
};

export default ContactType;
